import I18nRepository from './I18nRepository.js'

/**
 * @class
 * @implements I18nRepository
 */
export default class HTTPI18nRepository extends I18nRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {LiteralsValueObjectFactory} deps.valueObject
   * @param {Function} deps.log
   */
  constructor({valueObject, log} = {}) {
    super({valueObject, log})

    this._valueObject = valueObject
    this._log = log
  }

  /**
   * @return {Object}
   */
  getLiterals() {
    this._log('Getting i18n literals')

    return import('@adv-mt/mt-i18n-literals/dist/languages.json').then(module =>
      this._valueObject({
        literals: module.default
      })
    )
  }
}
